import { Box } from '@betterment/samba-react';

import { NarrowTypename } from '../../../../../graphql/utils/narrow-typename';
import { PurposeProjectionQuery } from '../../graphql/purposeProjection.generated';

type Props = {
  purpose: NarrowTypename<PurposeProjectionQuery['purpose'], 'PurposeMajorPurchase'>;
};

export const MajorPurchaseHeader = ({ purpose }: Props) => {
  const progressDescription = purpose.majorPurchaseProjection?.completion?.progressDescription;
  return progressDescription && <Box as="span">{progressDescription}</Box>;
};
